import "core-js/modules/es.regexp.exec.js";
import ENVIRONMENT_VARIABLES from '../constants/envVariables';
import { Environment } from '../types/Environment';
export var getEnvironment = function () {
  var ipRegex = /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/;
  var host = window.location.host;
  // if host is an ip address assume it is dev.
  // this is so we can connect from a VM and have the dev environment variables.
  // could update in the future to check for private IPs since that is all we really care about
  if (host.indexOf('localhost') > -1 || ipRegex.test(host)) {
    return Environment.DEV;
  }
  if (host.indexOf('-np') > -1 || host.indexOf('np-') > -1 || host.indexOf('-np-') > -1) {
    return Environment.NON_PROD;
  }
  return Environment.PROD;
};
export var isProd = function () {
  return getEnvironment() === Environment.PROD;
};
export var isNonProd = function () {
  return getEnvironment() === Environment.NON_PROD;
};
export var isDev = function () {
  return getEnvironment() === Environment.DEV;
};
export var getEnvVariable = function (key) {
  var variablesMap = ENVIRONMENT_VARIABLES[key];
  switch (getEnvironment()) {
    case Environment.DEV:
      return variablesMap.dev;
    case Environment.NON_PROD:
      return variablesMap.nonProd;
    default:
      return variablesMap.prod;
  }
};